
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "LoginSite",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    LoginForm,
  },
};
